export const CASHBACK_APPLIED_TEXT = 'Cashbacks Applied';
export const HIDE_TEXT = 'Hide';
export const SHOW_TEXT = 'Show';
export const TO_TEXT = 'To';
export const OFFER_ID_TEXT = 'Offer Id';
export const PAYMENT_SUCCESSFUL = 'Payment Successful';
export const PAYMENT_PENDING = 'Payment Pending';
export const PAYMENT_FAILED = 'Payment Failed';
export const SETTLEMENT_UTR_TEXT = 'Settlement UTR';
export const PAID_TO_TEXT = 'Paid to';
export const PAID_BY_TEXT = 'Paid by';
export const UTR_TEXT = 'UTR:';
export const ARN_TEXT = 'ARN: ';
export const TID_TEXT = 'Merchant TXN ID:';
export const PROVIDER_REF_ID = 'PhonePe Transaction ID:';
export const REFUNDS = 'Refunds';
export const RESOLVE = 'Resolve';
export const TRANSACTION_DETAILS = 'Transaction Details';
export const CONTACT_SUPPORT = 'Contact Support';
export const REFUND = 'Refund';
export const CREATED = 'CREATED';
export const CREATING = 'CREATING';
export const ACTIVE = 'ACTIVE';
export const COMPLETED = 'COMPLETED';
export const CANCELLED = 'CANCELLED';
export const FAILED = 'FAILED';
export const ERRORED = 'ERRORED';
export const EXPIRED = 'EXPIRED';
export const INITIATED = 'INITIATED';
export const SETTLED = 'SETTLED';
export const PENDING = 'PENDING';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const PAYMENT_INITIATED = 'PAYMENT_INITIATED';
export const CLOSED = 'CLOSED';
export const FULFILLMENT_DONE = 'FULFILLMENT_DONE';
export const REFUND_NOTE = 'Refund Note:';

export const REASON_FOR_REFUND = 'Reason for Refund';
export const REFUND_COMPLETE_AMOUNT = 'Refund Complete Amount';
export const REFUND_AMOUNT = 'Refund Amount';
export const PAY_THE_REFUND = 'Pay Refund';
export const CANCEL = 'Cancel';
export const REFUND_PAYMENT = 'Refund Payment?';
export const REFUND_MODAL_SUBTITLE = 'Do you want to save or discard changes?';
export const REFUND_INITIATED_TITLE = 'Refund Initiated';
export const REFUND_PENDING_TITLE = 'Refund Pending';
export const REFUND_FAILED_TITLE = 'Refund Failed';
export const REFUND_INITIATED_MESSAGE =
	'The transaction will be refunded to the source as requested';
export const REFUND_PENDING_MESSAGE =
	'It does not indicate failed payment. Check refund status before retrying the refund';
export const OKAY = 'Okay';
export const REFUND_AMOUNT_EMPTY = '* Refund amount cannot be empty';
export const REFUND_REASON_EMPTY = '* Refund reason cannot be empty';
export const MINIMUM_REFUND_AMOUNT_ERROR = '* Minimum Refund Amount is ₹1';
export const MAXIMUM_REFUND_AMOUNT_ERROR =
	'* Refund amount should not exceed the refundable amount';
export const MAXIMUM_PRECISION_ALLOWED =
	'Amount with up to two decimal places is allowed';
export const INVALID_AMOUNT = '* Enter a valid amount';
export const FULL_REFUND_TOOLTIP_TEXT =
	'Full Refund is not allowed for this transaction as Amount for Refund is less than Transaction Amount.';

export const SETTLEMENT_TEXT = {
	SETTLED: 'Settlement successful',
	PENDING: 'Settlement pending',
	FAILED: 'Settlement failed',
};

export const TRANSACTION_DETAILS_INFO_TEXT = {
	SETTLEMENT_PENDING:
		'The status indicates that the settlement process for this transaction is currently in progress/ not done.',
	UTR: 'Special code given to each transaction. Importantly, a UTRN is generated only when a transaction is successfully settled.',
	MERCHANT_ID:
		'This is a unique identifier assigned for the merchant to each transaction. It helps merchants track and manage their transactions more effectively.',
	REFUND:
		'This section details out the partial or the full amount returned against the transaction to the customer. ',
	CASHBACK:
		'This section details out the cashback received against the TRANSACTION',
};

export const STATUS_TEXTS = {
	SETTLEMENT_COMPLETED:
		'Settlement report is available after few hours of successful settlement, Please try after some time.',
	REPORT_NOT_READY_TO_BE_GENERATED:
		'Settlement report is available after few hours of successful settlement. Please try after some time.',
	DATA_INGESTION_COMPLETED:
		'The settlement report is ready. Click on "Generate Report" to download or share it in CSV format.',
	IN_PROGRESS:
		'Settlement report has been successfully requested. Please visit after some time.',
	SUCCESSFUL:
		'The settlement report is ready for Download. Click on 	"Download Report" to download it.',
	FAILED: 'Something went wrong. Please try again after sometime.',
};

export const REFUND_STATUS_ENUM = {
	INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
	PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
	PAYMENT_ERROR: 'PAYMENT_ERROR',
	PAYMENT_PENDING: 'PAYMENT_PENDING',
};

export const ONLINE_PRODUCT_TYPE_MAPPING = {
	PayLinks: 'Payment Link',
	'PhonePe PG': 'PhonePe PG',
	'PhonePe Container': 'PhonePe Container',
	'PhonePe PG Checkout': 'PhonePe PG',
	'Subscriptions Setup': 'Subscriptions Setup',
	'Subscriptions Redemption': 'Subscriptions Redemption',
};

export const ONLINE_SUBSCRIPTION_FREQUENCY = {
	DAILY: 'Daily',
	WEEKLY: 'Weekly',
	MONTHLY: 'Monthly',
	YEARLY: 'Yearly',
	FORTNIGHTLY: 'Fortnightly',
	BIMONTHLY: 'Bimonthly',
	ON_DEMAND: 'On Demand',
	QUARTERLY: 'Quarterly',
	HALFYEARLY: 'Half Yearly',
} as Record<string, string>;

export const ONLINE_SUBSCRIPTION_AMOUNT_TYPE = {
	FIXED: 'Fixed',
	VARIABLE: 'Variable',
} as Record<string, string>;

export const ONLINE_SUBSCRIPTION_AUTH_WORKFLOW_TYPE = {
	PENNY_DROP: 'Penny Drop',
	TRANSACTION: 'Transaction',
} as Record<string, string>;

export const PAYLINK_COPIED = 'Paylink Copied';
